module.exports = {
  GROUP_TYPE_CLASS: "CLASS",
  GROUP_TYPE_GROUP: "GROUP"
};
